import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText, ImageEdit } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { AutoWidthCol, Col, ContentRow, TextBackgroundWrapper } from "./ui"

const ImageView = (props) => {
  const { layout, data } = props

  const { templateVariables } = useBlocksConfig()

  const imageProps = {
    image: data.src,
    altText: data.altText,
    caption: data.caption,
    annotations: (data.annotations || []).filter((a) => a.html),
    readOnly: true
  }

  if (layout === "fullwidth") {
    return <ImageEdit {...imageProps} captionEnabled />
  }

  if (layout === "center") {
    return (
      <Content.Container flexForPrint={true}>
        <ImageEdit {...imageProps} captionEnabled />
      </Content.Container>
    )
  }

  if (layout === "annotated") {
    return (
      <div>
        <ImageEdit {...imageProps} annotationsEnabled captionEnabled />
      </div>
    )
  }

  if (layout === "text") {
    return (
      <ContentRow style={{ alignItems: "center" }} flexForPrint={true}>
        <AutoWidthCol>
          <ImageEdit {...imageProps} />
        </AutoWidthCol>
        <Col style={{ minWidth: 300, padding: 20 }}>
          <BlockText html={data.text} templateContext={templateVariables} />
        </Col>
      </ContentRow>
    )
  }

  if (layout === "text_background") {
    return (
      <TextBackgroundWrapper textColor="white">
        <ImageEdit {...imageProps} backgroundMode />
        <Content.Container style={{ position: "relative" }}>
          <BlockText html={data.text} templateContext={templateVariables} />
        </Content.Container>
      </TextBackgroundWrapper>
    )
  }

  return null
}

export default ImageView
